import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOccupancyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7891 18.7891V10L10 1.21094L1.21094 10V18.7891",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 10.8789C6.77734 11.7336 7.11687 12.5533 7.72124 13.1577C8.3256 13.762 9.1453 14.1016 10 14.1016C10.8547 14.1016 11.6744 13.762 12.2788 13.1577C12.8831 12.5533 13.2227 11.7336 13.2227 10.8789C13.2227 10.0242 12.8831 9.20451 12.2788 8.60014C11.6744 7.99578 10.8547 7.65625 10 7.65625C9.1453 7.65625 8.3256 7.99578 7.72124 8.60014C7.11687 9.20451 6.77734 10.0242 6.77734 10.8789Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9727 18.7898C14.6091 17.7614 13.9357 16.8711 13.0452 16.2413C12.1546 15.6116 11.0907 15.2734 10 15.2734C8.90928 15.2734 7.84539 15.6116 6.95484 16.2413C6.06428 16.8711 5.39087 17.7614 5.02734 18.7898",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOccupancyIcon;
